module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/16V1QuA/images/e9781439627877_cover.jpg?1684255542145",
      "alt": "This image is the cover for the book Pontiac, Michigan, Postcard History"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Pontiac, Michigan, Postcard History\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("\"I am sending you this so you won't forget Pontiac.\" This is the sentiment inscribed on one of the postcards included in this collection. Pontiac, Michigan: A Postcard Album brings to life the history of this uniquely American city. The postcard has always been a very popular means of communication, and now as a historical document, it offers us a fascinating insight into the times and places of the past. Like many cities, Pontiac has passed through many phases, from agricultural center to auto manufacturer�through good times and bad. These postcards capture the people and places of Pontiac, and remind us of the courageous people who built this country.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Gottfried Brieger\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Gottfried Brieger has collected nearly 200 images to tell the story of Pontiac, from the early days to the present-bringing the past to life.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0